export var WSKind;
(function (WSKind) {
    WSKind["Init"] = "init";
    WSKind["Create"] = "create";
    WSKind["Join"] = "join";
    WSKind["ReqState"] = "req-state";
    WSKind["State"] = "state";
    WSKind["Win"] = "win";
})(WSKind || (WSKind = {}));
